import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faBenchTree,
    faBuilding,
    faChartLine,
    faClipboardList,
    faCrown,
    faFileChartColumn,
    faFileSignature,
    faList,
    faTag,
    faUsers,
    faWandMagicSparkles
} from '@fortawesome/pro-light-svg-icons';
import { PlanTier } from './Subscriptions';

export interface PlanTierContent {
    name: string;
    description: string;
}

export const PLAN_TIER_CONTENT: Record<PlanTier, PlanTierContent> = {
    starter: {
        name: 'Starter',
        description: 'Perfect for solo pet pros. Because we understand the challenges and want to support your journey.'
    },
    premium: {
        name: 'Premium',
        description: 'Everything in Starter, plus the tools to grow and manage a busier business.'
    },
    elite: {
        name: 'Elite',
        description:
            'Perfect for sophisticated business looking to scale while delivering the best possible customer experience.'
    }
};

export interface PlanEntitlement {
    icon: IconDefinition;
    label: string;
}

export const PLAN_ENTITLEMENTS: Array<PlanEntitlement> = [
    { icon: faUsers, label: 'Staff Unlimited' },
    { icon: faFileChartColumn, label: 'Service Reports' },
    { icon: faFileSignature, label: 'Agreements' },
    { icon: faChartLine, label: 'Advanced Analytics' },
    { icon: faClipboardList, label: 'Evaluations' },
    { icon: faTag, label: 'Products' },
    { icon: faList, label: 'Task & Activities' },
    { icon: faCrown, label: 'Memberships & Packages' },
    { icon: faBenchTree, label: 'Rooms & Spaces' },
    { icon: faWandMagicSparkles, label: 'Cuddles AI' },
    { icon: faBuilding, label: 'Multiple Locations' },
    { icon: faChartLine, label: 'Insights' }
];
